import { Box, Typography } from "@mui/material";
import UnderlineButton from "../buttons/underlineButton.component";

const NoFilterNotesEmptyState = ({ onClick }) => {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={2}
    >
      <Typography fontSize="20px" fontWeight="bold">
        Nessuna nota trovata
      </Typography>
      <Typography fontSize="14px">
        Non è stata trovata nessuna nota associata alla tua ricerca. Prova a
        cambiare i filtri.
      </Typography>
      <UnderlineButton label="Reset filtri" color="inherit" onClick={onClick} />
    </Box>
  );
};

export default NoFilterNotesEmptyState;
